// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "chunk." + {"582": "a697a4e13b332689","846": "f06b58ab96dca518",}[chunkId] + ".js"
}